import { Settings } from "../../../Settings";
import GridTile from "../../grid/GridTile";
import PathPlan from "./PathPlan";
import Vector from "../../math/Vector";
import Character from "../../character/Character";

export default class PathPlanFallDownRight extends PathPlan {
    /**
     * @param {GridTile} startTile 
     * @param {GridTile} endTile 
     * @param {number} pathSteps
     */
    constructor(startTile, endTile, pathSteps) {
        super(startTile, endTile, pathSteps);

        /**
         * @private
         * @constant
         * @type {Vector}
         */
        this.landCoordinate = new Vector();
    }

    /**
     * @override
     * @param {Character} character 
     * @param {number} frameTimeRatio 
     * @param {boolean} turnStart True if this is the start of a turn.
     * @return {boolean} True when the step is completed.
     */
    executePlan(character, frameTimeRatio, turnStart) {

        // jump pixel: right edge of start tile
        // land pixel: left edge of end tile
        const fallCoordinate = this.startTile.origin;
        const fallCoordinateX = fallCoordinate.x + Settings.tile.size + Settings.character.halfWidth;  // we should walk until we just pass the start tile origin
        
        /////////////////////////////////////////////
        // Walk to fall coordinate
        /////////////////////////////////////////////

        if (character.position.worldCoordinateCenter.x < fallCoordinateX) {
            this.walkRightToCenterX(character, frameTimeRatio, fallCoordinateX);
            return false;
        }

        /////////////////////////////////////////////
        // Fall down & Right
        /////////////////////////////////////////////

        // Land on the center of the end tile maybe
        this.landCoordinate.copy(this.endTile.origin);
        this.landCoordinate.addXY(Settings.tile.halfSize, 0); 
        
        if (character.position.worldCoordinateCenter.x < this.endTile.origin.x || character.position.worldCoordinateOrigin.y < this.endTile.origin.y) {
            this.fallDownAndRight(character, frameTimeRatio, this.landCoordinate);
            return false;
        }
    
        this.assertEndTileReached(character, this.endTile);
        
        return true;
    }
    
    /**
     * @returns {String}
     */
    toString() {
        return 'FallDownRight(' + this.pathSteps + ')';
    }
}